import { render, staticRenderFns } from "./WorkOrderManagementDetail.vue?vue&type=template&id=f5d610ca"
import script from "./WorkOrderManagementDetail.vue?vue&type=script&lang=js"
export * from "./WorkOrderManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderManagementDetail.vue?vue&type=style&index=0&id=f5d610ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports